min_width=undefined;
max_width=undefined;
min_width_T=undefined;
max_width_T=undefined;

if (!Object.keys) {
  Object.keys = (function () {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) throw new TypeError('Object.keys called on non-object');

      var result = [];

      for (var prop in obj) {
        if (hasOwnProperty.call(obj, prop)) result.push(prop);
      }

      if (hasDontEnumBug) {
        for (var i=0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
        }
      }
      return result;
    }
  })()
};

if(!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g,'');
  };
}

if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    var T, k;

    if (this == null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as the this value and
        // argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

//	Auto Notify
var bzzBzz = navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate ||  navigator.msVibrate;
loggedin = $('.js-login-link.logout-link').length ? true : false;
function ValidateEmail(email, allowBlank){
	if(allowBlank && email.trim().length === 0) {
		return true;
	}
	if (isValidEmailAddress(email)) {
		return true;
	} else {
		alert("Please input a valid email address!");
		return false;
	}
}

//	Show cats
function displayCategory(selectedCategory){
	$('#' + selectedCategory).show();
}

var detectScroll = function(el){
	var x = document.querySelector(el);
	return x.scrollHeight > x.clientHeight ? true : false;
};

//	Equal Heights
var eqHeights = (function(){
	var selector, plusSome;
	var getHeight = function(selector){
		$(selector).height('');
		var theGroup = [], setter = 0;
		$(selector).each(function(){
			theGroup.push($(this).innerHeight().toFixed());
			setter = Math.max.apply(Math, theGroup);
		});
		return setter;
	};
	return{
		set: function(options, cb){
			selector = options.selector || '.eqHeight';
			plusSome = options.plusSome || 0;
			plusSome ? $(selector).height(getHeight(selector) + plusSome) : $(selector).height(getHeight(selector));
			if(typeof cb === 'function'){ cb(); }
		}
	};
})();

//  Screen breakpoints
var pointsBreak = (function(){
	var time = 500, W, H;
	var doWork = function(context){
		W = window.innerWidth || document.documentElement.clientWidth,
		H = window.innerHeight || document.documentElement.clientHeight;
		for(var i in context){
      if(isNaN(i)){
        var type = i[0].toUpperCase() === 'W' ? W : H,
          test = i[1], dims = i.split(i[1])[1], myFunc = context[i];
        if(test === '>' && type > dims || test === '<' && type < dims){ runThis(myFunc); }
      }
		}
	};
	var runThis = function(fin){
		if(typeof fin === 'function'){ fin(); }
	};
	return{
		init: function(context){
			var doIt;
			doWork(context);
			window.onresize = function(){
				clearTimeout(doIt);
				doIt = setTimeout(function(){doWork(context);}, time);
			};
		},
		setDelay: function(x, finFunc){
			time = x;
			runThis(finFunc);
		},
		imgSwap: function(selector){
			var x = this,
        el = document.querySelectorAll(selector);
      for(var i = 0; i < el.length; i++){
        var me = el[i];
        if(x.getWidth() >= me.getAttribute('data-bp')){
					me.setAttribute('src', me.getAttribute('data-big'));
				}else{
					me.setAttribute('src', me.getAttribute('data-small'));
				}
      }
		},
		getWidth: function(){ return W; },
		getHeight: function(){ return H; }
	};
}());

var isMobile = false,
    contentOffSet;

//  Toggle mobile
var mobileInit = function(){
    if(isMobile === false || isMobile === undefined){
        $('body').addClass('mobi');
        $('#menu-wrapper #tab').removeClass('open').next('#menu').hide();
        $('body#home #tab').addClass('carSelTgl');
        $('.vstep').not(':first-child').hide();
        if($('#customer-links li').hasClass('login')){
            $('body, #customer-links').addClass('notLoggedIn');
        }else if($('#customer-links li').hasClass('logout')){
            $('body, #customer-links').addClass('loggedIn');
        }
        isMobile = true;
    }
    //setNavHeight();   Running this causes errors undefined errors on Turner pages.
};

//  End mobile
var mobileTerminate = function(){
    $('body').removeClass('notLoggedIn loggedIn mobi searchOpen');
    $('#menu-wrapper #tab').removeClass('open');
    $('#home #menu-wrapper #tab').addClass('open').removeClass('carSelTgl');
    $('.vstep').show();
    $('#menu, #search-wrapper, #search-wrapper form, .mobileBodyWrap, #trending-wrapper').removeAttr('style');
    isMobile = false;
};

//  Always run on resize
var globalResizr = function(){
    if($('body').hasClass('aboutuspage')){
        contentOffSet = $('#content').height() - $('#content').height() / 6;
    }
    if($('.swap')){ pointsBreak.imgSwap('.swap'); }
    if($('.myaccount.login:not(#salesLogin)').length){
        if(pointsBreak.getWidth() <= 685) {
            $('#wrapper-new_customer form,#wrapper-returning_customer,#otherLogin').removeAttr('style');
        }
    }
    if($('body').hasClass('checkoutpage') && window.suggestionItemHeights){
        pointsBreak.getWidth() > 480 ? suggestionItemHeights() : $('.product-container').removeAttr('style').find('.pricing').removeClass('shown').removeAttr('style');
    }
};

//	Set category nav height
function setNavHeight(){
    var headerHeight = $('#header').height(),
        $theOffset = $('#customer-links').offset().top,
        nH = (window.innerHeight - headerHeight) - $theOffset;
    $('.mobileNav').css({'height' : nH, 'top' : $('.mobileBodyWrap').offset().top});
    if($('body').hasClass('.showingNav')){
        $('.mobileBodyWrap').css('height', nH);
    }
}

// touch
var touchy = (function(){
    var defaults = {
        selector: '.touchee',
        distance: 50,
        tapOffset: 10
    };
    var overflowScroll = function(el){
        $(el).each(function(){
            var $this = $(this),
            scrollStartPosY = 0,
            scrollStartPosX = 0;
            $this.on('touchstart', function(e){
                scrollStartPosY = this.scrollTop + e.originalEvent.touches[0].pageY;
                scrollStartPosX = this.scrollLeft + e.originalEvent.touches[0].pageX;
            });
            $this.on('touchmove', function(e){
                e.preventDefault();
                this.scrollTop = scrollStartPosY - e.originalEvent.touches[0].pageY;
                this.scrollLeft = scrollStartPosX - e.originalEvent.touches[0].pageX;
            });
        });
    };
    var canTouch = function(){
        try{
            document.createEvent('TouchEvent');
            return true;
        }catch(e){
            return false;
        }
    };
    var getEvnt = function(e){
        return e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0] : e;
    };
    var apply = function(el, dist, tapOffset){
        var el = el || defaults.selector,
            dist = dist || defaults.distance,
            touching;
        $(el).each(function(){
            var $touchArea = $(this),
                startTarget,
                startX, startY,
                mX, mY,
                startTime, endTime;
            $touchArea.on('touchstart',function(e){
                var touchPoint = getEvnt(e);
                touching = true;
                startX = mX = touchPoint.pageX;
                startY = mY = touchPoint.pageY;
                startTime = e.timeStamp;
                startTarget = e.target;
            });
            $touchArea.on('touchend', function(e){
                tapOffset = tapOffset || defaults.tapOffset;
                var $this = $(this);
                endTime = e.timeStamp,
                xDiff = mX - startX,
                yDiff = mY - startY,
                absXdiff = Math.abs(xDiff),
                absYdiff = Math.abs(yDiff);
                if(endTime - startTime <= 400 && absXdiff <= tapOffset && absYdiff <= tapOffset && startTarget === e.target){
                    $this.trigger('tapClick');
                    setTimeout(function(){
                        touching = false;
                    },310);
                }else{
                    if(absXdiff >= dist && absYdiff){
                        if(xDiff < 0){
                            $this.trigger('swipeLeft');
                        }else{
                            $this.trigger('swipeRight');
                        }
                    }else if(absYdiff >= dist && absXdiff){
                        if(yDiff < 0){
                            $this.trigger('swipeUp');
                        }else{
                            $this.trigger('swipeDown');
                        }
                    }
                    touching = false;
                }
            });
            $touchArea.on('click', function(e){
                e.preventDefault();
                var myTime = e.timeStamp,
                    dif = endTime - myTime;
                if(isNaN(dif) && !touching || dif >= 0 && !touching){
                    $(this).trigger('tapClick');
                }
            });
            $touchArea.on('touchmove',function(e){
                e.preventDefault();
                var touchPoint = getEvnt(e);
                mX = touchPoint.pageX;
                mY = touchPoint.pageY;
            });
        });
    };
    return{
        register: function(el, type, dur){
            apply(el, type, dur);
        },
        test: function(){
            return canTouch();
        },
        overflowFxr: function(el){
            overflowScroll(el);
        }
    };
})();

//	Animated panels for terms & aboutus pages
//--------------------------------------------
var flashPanels = {
    init: function(panelSelector, toggleSelector, speed, scrollOffSet, finFunc){
        $(toggleSelector).on('click', function (e){
            var i = $(this).index(),
                myPanel = $(panelSelector).eq(i),
                $this = $(this);
            e.preventDefault();
            $(toggleSelector).removeClass('active');
            $this.addClass('active');
            if (!myPanel.is(':visible')) {
                $(panelSelector).not(myPanel).fadeOut(speed, function(){
                    if(scrollOffSet === false){
                        myPanel.delay(200).fadeIn(speed, function(){
                            flashPanels.finito();
                        });
                    }else{
                        $('html,body').stop().animate({ scrollTop: $(scrollOffSet).offset().top }, speed, function(){
                            myPanel.delay(200).fadeIn(speed, function(){
                                flashPanels.finito();
                            });
                        });
                    }
                });
            }
        });
    },
    gotoContent: function(panelNav, paneSelector, myPane, mySubSection, speedOut, speedIn, scrollSpeed){
        $(paneSelector).not(myPane).fadeOut(speedOut, function(){
            $(myPane).fadeIn(speedIn, function(){
                if(mySubSection){
                    $('html,body').stop().animate({scrollTop: $(mySubSection).offset().top }, scrollSpeed);
                }else {
                    $('html,body').stop().animate({scrollTop: $(myPane).offset().top }, scrollSpeed);
                }
            });
        });
        $(panelNav).find('.active').removeClass('active').end().find('a[href="' + myPane + '"]').parent('li').addClass('active');
    },
    finito: function(finFunc){
        if(typeof finFunc === 'function'){ finFunc(); }
    }
};

function clearInput(el) {
	if (el.defaultValue == el.value) el.value = "";
}

var emailLink = function () {
	document.write('<a');
	document.write(' href="mailto:email@somedomain.com?subject=Check out this ECS Tuning product!&amp;body=Take a look at this: ' + top.location.href);
	document.write('"><img src="' + CDNpath + '/img/icons/email.gif" width="10" height="10" border="0" alt="" style="margin-right:3px">E-mail this to a friend</a>');
}

function openWindow(url) {
	window.open(url, 'height=500,width=700,scrollbars=no');
}

/////////////////////////////////*\///////////
// Video Window Resize

function videoWindow(resolution, videoID) {
	var isSafari = (navigator.userAgent.indexOf("Safari") >= 0) ? 1 : 0;
	var x;
	var y;
	var file; {
		if (resolution == "HD") {
			x = 1280;
			y = 764;
		} else {
			x = 640;
			y = 390;
		}
		if (isSafari == 0) {
			y = y + 28;
		}
		window.open('Video' + videoID + '-' + resolution + '/', 'videopopup', 'width=' + x + ',height=' + y + ',menubar=no,directories=no,status=no,resizable=yes,location=yes,toolbar=no,scrollbars=no');
	}
}
////////////////////////////////////////////
// Vehicle Selection Drop-Downs
////////////////////////////////////////////
var currentVSelectContainer = false;

function buildList(data) {
    var line = data.split("\n");
    // get the Submit Button so we can disable and enable it when needed
    var submitButton = currentVSelectContainer.nextAll('button');
    //store the steps that need to be generated
    var createdSteps = {};
    var options = 0;
    var vStep = false;

    //parse the AJAX response
    for (var i = 0; i < line.length; i++) {
        var lineElements = line[i].split("::");
        if (lineElements[0] == "END") {
            disableStep(vStep, options);
            submitButton.removeAttr('disabled').removeClass('disable').show();
            $('.endShow').show();
        } else {
            submitButton.attr('disabled', 'disabled').addClass('disable');
            $('.endShow').hide();
            if (!(lineElements[0] in createdSteps)) {
                disableStep(vStep, options);

                //initialize the options count for this new select drop down
                options = 0;
                //create the select element and add the name
                var newStep = $('<select></select>').attr('name', lineElements[0]).addClass('vstep');	//.attr('tabindex', '-1');
                //request for data to populate this select drop down
                newStep.change(selectStep);
                currentVSelectContainer.append(newStep);
                eval('createdSteps.' + lineElements[0] + ' = newStep');
            }
            vStep = eval('createdSteps.' + lineElements[0]);
            //add the data as an option to the select drop down
            vStep.append($('<option></option>').val(lineElements[2]).html(lineElements[1]));
            options++;
        }
    }

    if(vehicleInit
        && currentSetStep >= selectedSteps.length
        ) {
        //the initialization of vehicle drop downs it's done
        vehicleInit = false;
    }
}

function disableStep(vStep, options) {
	if (options == 1) {
		vStep.css({
			color: '#000',
			background: '#999',
			border: '1px solid #999'
		});
    }
}

function selectStep(event) {
	var target = (event.target) ? event.target : event.srcElement;
	changeStep($(target));
}

function changeStep(stepSelect) {
	// Set the global currentVSelectContainer var
	currentVSelectContainer = stepSelect.parent('div');
	// Remove all the selects that follow the modified select
	stepSelect.nextAll('select').remove();
	//un-highlight the select if a correct selection was made
	if (!vehicleInit) {
		//vehicleInit is only true when the page loads with an error: Incomplete information
		stepSelect.attr('class', 'vstep');

		if (stepSelect.val() == 'n') {
			// disable the Submit Button
			currentVSelectContainer.nextAll('button').attr('disabled', 'disabled').addClass('disable');
			return;
		}
	}

	var requestURL = '/includes/vehicleMap.cgi?vehicleSelection=1';
	var checkSteps = stepSelect.prevAll('select');
	checkSteps.push(stepSelect[0]);
	$.each(checkSteps, function (i, checkStep) {
		if (vehicleInit && i <= checkSteps.length) value = $(checkStep).val();
		else value = $(checkStep).val();
		// Build the URL request; encode the values in order to escape special characters like '+'
		requestURL += '&' + $(checkStep).attr('name') + '=' + encodeURIComponent(value);
	});

    $.ajax({
        'url'      : requestURL,
        'type'     : "GET",
        'dataType' : "text",
    })
    .done(function(data) {
	if(currentVSelectContainer.parent('#doesItFit'))
		{$('.fitsMessage').addClass('hidden');}
        buildList(data);
    });
}
var currentSetStep = 0;

function setStep(stepNum) {
	// stepNum is an index of the selectedSteps array which is used for initializing the vehicle info
	currentSetStep = stepNum;

	var stepElements = selectedSteps[stepNum - 1].split("::");
	if (contentForm.length == 0) contentForm = $('#header-wrapper');
	var stepSelect = contentForm.find('select[name$="' + stepElements[0] + '"]');

	if (stepSelect.length == 0)
		return;

	stepSelect.val(stepElements[1]);

	if (stepSelect.val() == 'n') {
		//highlight the drop down that doesn't have a selection
		stepSelect.addClass('error');
	}

	changeStep(stepSelect);
}

// End: Vehicle Selection Drop-Downs

function isValidEmailAddress(email) {
	if(email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([^<>()[\]\\.,;:\s@\"]+\.)+[a-zA-Z]{2,}))$/i)) {
		return true;
	} else {
		return false;
	}
}

var dynContent = (function(){
	var lnkClk;
	return {
		settings: {
			toggles: '',
			closeBtn: '',
			container: '',
			toLoad: '',
			originalContent: '',
			loadImg: '',
			speed: '',
			init: ''
		},
		getQs: function(){
			var qs = window.location.href.split('?');
			if(qs[1]){
				return qs[1];
			}else{
				return undefined;
			}
		},
		closeLoaded: function(){
			var x = this.settings;
			window.location.hash = '#';
			$(x.container).addClass('working');
			$(x.toLoad).fadeOut(x.speed, function(){
				$(this).remove();
				$('#loadedStyle').remove();
				$(x.originalContent).fadeIn(x.speed, function(){
					$(x.container).removeClass('working');
				});
			});
			lnkClk = 0;
		},
		loadContent: function(ruf){
			var x = this.settings;
			if(this.getQs() !== ''){
				var url = ruf || this.getQs();
				if(ruf !== undefined){
					window.location.hash = '#?' + url;
				}
				$(x.container).addClass('working');
				$('head').append('<link id="loadedStyle" type="text/css" rel="stylesheet" href="' + url + '/style.css"/>');
				$(x.originalContent).fadeOut(x.speed, function(){
					$('html,body').animate({ scrollTop: $(x.container).offset().top }, 'fast');
					$('body').append(x.loadImg);
					$('body').find('img').last().addClass('ajaxyLoader');
					$.ajax({
						url:url,
						type:'GET',
						success: function(data){
							var d = $('<div>').html(data);
							$(x.container).append(d.find(x.toLoad).css('display', 'none'));
							$('.ajaxyLoader').delay(500).fadeOut(x.speed, function(){
								$(this).remove();
								$(x.toLoad).fadeIn(x.speed, function(){
									$(x.container).removeClass('working');
									pointsBreak.imgSwap('.imgSwap');
								});
							});
						}
					});
				});
			}
		},
		init: function(){
			var x = this.settings;
			if(dynContent.getQs()){
				lnkClk = 1;
				dynContent.loadContent();
			}
			$(x.toggles).each(function(){
				if(!$(this).hasClass('disabled')){
					$(this).on('click', function(e){
						lnkClk = 1;
						e.preventDefault();
						dynContent.loadContent($(this).attr('href'));
					});
				}
			});
			$('body').on('click', x.closeBtn, function(){
				dynContent.closeLoaded();
			});
			$(window).on('hashchange', function(){
				if(lnkClk !== 1 && dynContent.getQs() !== undefined){
					dynContent.loadContent();
				}else if(window.location.hash == '#' || window.location.hash == ''){
					dynContent.closeLoaded();
				}
			});
		}
	};
}());

// Sets up Click Listener for Free Shipping Disclaimer Popup on jquery selected elements
function freeShippingPopup($elements) {
	$elements.click(function() {
		$this = $(this);
		// Remove any stock boxes already open
		$('.modalStockBox').remove();
		// HTML stored as a variable
		var disclaimer = $(
			'<div class="modalStockBox modalFreeShipping">'
				+ '<img src="' + CDNpath + '/img/icons/freeshipping.gif" width="23" height="14" alt="Shipping Truck" >'
				+ 'Free shipping applies to orders shipped within the contiguous U.S. only.'
				+ '<span class="btnClose">Close</span>'
			+ '</div>'
		);

		// use the modal-target area on product landing pages
		modalTarget = $('.modal-target');
		if(modalTarget.length === 0){ modalTarget = $this.prev(); }

		// Append Disclaimer HTML into the Free Shipping Div
		modalTarget.after(disclaimer);
		// Remove Disclaimer After 5 Seconds
		dTimer = setTimeout(function(){
			disclaimer.remove();
		}, 5000);
		// Close Disclaimer Box using Close button
		disclaimer.find('.btnClose').click(function(){
			dTimer = false;
			disclaimer.remove();
		});
	});
}

// Sets up Click Listener for Free Shipping Eligible Disclaimer Popup on jquery selected elements
function freeShippingEligiblePopup($elements) {
	$elements.click(function() {
		$this = $(this);
		// Remove any stock boxes already open
		$('.modalStockBox').remove();
		// HTML stored as a variable
		var disclaimer = $(
			'<div class="modalStockBox modalFreeShippingEligible">'
				+ '<img src="' + CDNpath + '/img/icons/freeshippingeligible.gif" width="23" height="14" alt="Shipping Truck" />'
				+ 'Items marked with a “Free Shipping Eligible” logo may qualify for free ground shipping within the contiguous US (48 states) for most orders with a value greater or equal to $200.00 USD. '
				+ '<span class="btnClose">Close</span>'
			+ '</div>'
		);

		// use the modal-target area on product landing pages
		modalTarget = $('.modal-target');
		if(modalTarget.length === 0){ modalTarget = $this.prev();}

		// Append Disclaimer HTML into the Free Shipping Eligible Div
		modalTarget.after(disclaimer);
		// Remove Disclaimer After 5 Seconds
		dTimer = setTimeout(function(){
			disclaimer.remove();
		}, 5000);
		// Close Disclaimer Box using Close button
		disclaimer.find('.btnClose').click(function(){
			dTimer = false;
			disclaimer.remove();
		});
	});
}

function selectSearchOption(option) {
    $(".search-more-menu-selected").removeClass("search-more-menu-selected");
    $('#search-more-menu').hide();
    if($('#' + option).hasClass("search-more-menu-selected")) {
        $('#searchMoreSelected').val("SiteSearch");
        $('#' + option).removeClass("search-more-menu-selected");
    }
    else {
        $('#searchMoreSelected').val(option);
        $('#' + option).addClass("search-more-menu-selected");
    }
}

function submitFacebookLogin(auth) {
    auth.customer_login = "Facebook";

    var $form = $("<form>");
    $form.css("display", "none");
    $form.prop("method", "post");
    $form.prop("action", "./");
    $.each(auth, function(name, value) {
        var $input = $("<input>");
        $input.prop("name", name);
        $input.val(value);
        $form.append($input);
    });
    $("body").append($form);
    $form.submit();
}



////////////////////////////////////////////
// New Customer Email Popup 
////////////////////////////////////////////


window.mobileAndTabletcheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function deleteCookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
function removeCookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

var signupCookieExists = function(){

	if (getCookie("signupmodalDateEXP"))
	  return true;
	else
		return false;
};

function getKeyByValue (obj, value ) {
    if(typeof obj != 'object') return '';

    for( var prop in obj ) {
        if( obj.hasOwnProperty( prop )
            && obj[ prop ] === value
            ) {
            return prop;
        }
    }
}

$.fn.waitr=function(t,f){var el=$(this);setTimeout(function(){if(typeof f==='function'){f();}},t);return el;};

$.fn.showModal = function(opts, cb){
  var el= this;
  typeof opts === 'function' && arguments.length === 1 ? cb = opts : opts = opts || {};
  var $modal = $(this),
    bgColor = opts.bgColor || 'rgba(0,0,0,.7)',
    bgSpeed = opts.bgSpeed || 500,
    modalSpeed = opts.modalSpeed || 750,
    autoScroll = opts.autoScroll || false,
    scrollSpeed = opts.scrollSpeed || 500,
    offset = opts.offset || 75;
    $modalBg = $('<div class="zmodalBg" style="background-color: '+bgColor+'; position: fixed; z-index: 16777270; top: 0; left: 0; width: 100%; height: 100%; display: none;">');
  var completed = function(){
    $modal.addClass('showing').trigger('modalShown');
    if(typeof cb === 'function'){ cb.call(el); }
  };
  var doScroll = function(){
    $('html,body').animate({scrollTop: $modal.offset().top - offset}, scrollSpeed).promise().done(function(){
      completed();
    });
  };
  return this.each(function(){
    $modalBg.appendTo('body').fadeIn(bgSpeed, function(){
      $modal.css('z-index', 16777271).fadeIn(modalSpeed, function(){
        $(document).on('keyup.modal', function(e){
          if(e.keyCode === 27){ $modal.hideModal(); }
        });
        $modalBg.on('click.modal', function(){
          $modal.hideModal();
        });
      });
      autoScroll === true ? doScroll() : completed();
    });
  });
};

$.fn.hideModal = function(opts, cb){
  var el = this;
  typeof opts === 'function' && arguments.length === 1 ? cb = opts : opts = opts || {};
  var $modal = $(this),
    $modalBg = $('.zmodalBg'),
    modalSpeed = opts.modalSpeed || 750,
    bgSpeed = opts.bgSpeed || 500;
  var completed = function(){
    $modalBg.remove();
    $(document).off('keyup.modal');
    $modal.removeClass('showing').trigger('modalClosed');
    if(typeof cb === 'function'){ cb.call(el); }
  };
  $modal.fadeOut(modalSpeed, function(){
    $modalBg.fadeOut(bgSpeed, function(){
      completed();
		});
	});
	return this;
};

$.fn.showErrors = function()
{
	var $modal=$(this);
	if(!$modal.find('.errorTitle').length){
                $modal.find('h5 + p').after('<p class="errorTitle">Please fix the errors outlined below:</p>');
              }
              if(Modernizr.cssanimations){
                $modal.addClass('shake').waitr(500, function(){
                  $modal.removeClass('shake');
                  $submit.prop('disabled', false);
                });
              }else{
                var curLeft = parseFloat($modal.css('margin-left').split('px')[0], 10);
                shakeFallBack(curLeft, function(){
                  shakeFallBack(curLeft);
                });
              }

}

var vInfoAdd= function(e){

            if(e)
			{

				$('.errorTitle').remove();
				$(this).prop('disabled', true);
				$('.newCustModal .field, .newCustModal select').each(function(){
				         // vehicle select validation

					var $this = $(this);

					if($this.is('select') && $this.val() === 'n'){
						$this.addClass('error').on('blur.validate', function(){
							if($this.val() !== 'n'){
								$this.removeClass('error').off('blur.validate');
							}
						});
					}
				});
				if($modal.find('.error').length > 0){
					$modal.showErrors();
				}else{
					$("#newCustVehicleSubmit").after('<img id="waitVehicle" src="' + CDNpath + '/img/wait.gif" height="20px" style="float:right;position:relative;top:-22px; left:-20px">');
					$("#nCTY").val('n');
					$.ajax({
						url:'/Signup/',
						type:'post',
						data: $modal.find('form').serialize(),
						success: function(data){
							dataLayer.push({
										'event':'signupFromModal',
										'virtualPageURL':'/signupFromModal/thankYou',
										'virtualPageTitle' : 'Signup From Modal - Vehicle Submit'
									});
							$("#newCustVehicleSelect, #newCustVehicleSubmit, #waitVehicle, #newCustMessage").fadeOut(300);
							$("#newCustMessage, #newCustModal .modalBody h5").empty();
							$("#newCustMessage").append('<h5>Thanks. <br> Your vehicle has been saved!</h5>').fadeIn(300);
							setTimeout(function(){
								$modal.hideModal();
							}, 5000);
						},
						error: function(data){
							alert("Unable to complete request, please refresh the page or try again later. \n Error: " + data.responseText);
						}
					});
				}

			}
	};

var today = new Date();

	// Create LocalStorage Object set to expire at set 'days' from today.
var write = function(days){
        var expDate = new Date().setDate(today.getDate()+days);
		var d = new Date();
		d.setTime(d.getTime() + (90*24*60*60*1000));
		var expDateC = d.toUTCString();
		try {
        	localStorage.show = JSON.stringify({shown: 1, date: expDate});
			document.cookie="signupmodalDateEXP="+expDateC+"; expires="+expDateC;
		} catch (e) {
			// storage not enabled
		}

};

var $fitsVehicleAjax = false

function checkProductFitsVehicle() {
    var productID = $("input.productID").val()
      , $loading = $("img.loading")
      , $doesFit = $("p.doesFit")
      , $doesNotFit = $("p.doesNotFit")
      , $alineFit = $("p.alineFit")

    $loading.removeClass('hidden');
    $doesNotFit.addClass('hidden');
    $doesFit.addClass('hidden');
    $alineFit.addClass('hidden');

    if($fitsVehicleAjax) $fitsVehicleAjax.abort();

    var failure = function( data ) {
      var errMsg = data.errMsg || "Unknown";
      console.log("Failed to call fitsVehicle: " + errMsg);
      alert("Unable to determine vehicle fitment");
    };

    $fitsVehicleAjax = $.ajax({
      'url'      : "/fitsVehicle/",
      'type'     : "GET",
      'dataType' : "json",
      'data'     : {
        'productID' : productID,
      },
    })
    .done(function(data) {
      if(! data.success) return failure( data );

      if(data.fitsVehicle == -1) {    				 // a-line descriptions shown where applicable.
        $doesNotFit.addClass("hidden");
        $doesFit.addClass("hidden");
        $alineFit.removeClass("hidden");
        $alineFit.append('<span class="alineTxt" id="alineTxt">');
        $('#alineTxt').html(data.alineTxt);
      }
      else if(data.fitsVehicle){  					// Fits
        $doesNotFit.addClass("hidden");
        $alineFit.addClass("hidden");
        $doesFit.removeClass("hidden");
      }
      else{ 											  // Does Not Fit
        $doesFit.addClass("hidden");
        $alineFit.addClass("hidden");
        $doesNotFit.removeClass("hidden");
      }
    })
    .fail( failure )
    .always(function() {
      $loading.addClass("hidden");
    });
}

function isoDateFormatter(dateStr, monthAbbrev, includeYear) {
	// pass in "2018-01-01" and return January 1 or Jan 1
	var tmpDate = new Date(dateStr);
    if (isNaN(tmpDate)) { return dateStr; }
	monthAbbrev = monthAbbrev ? true : false;
	var monthNames = ["January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"];
	var tmpDate = new Date(dateStr);
	if (!tmpDate)
		return "";
	var tmpMonth = monthNames[tmpDate.getUTCMonth()];
	if (monthAbbrev)
		tmpMonth = tmpMonth.substring(0,3);
    if (includeYear)
        return tmpMonth + " " + tmpDate.getUTCDate() + ", " + tmpDate.getUTCFullYear();
	return tmpMonth + " " + tmpDate.getUTCDate();
}

registerScriptLoadCallback(function() {

	    if (Modernizr.mq('(min-width: 0px)')) {
      // Browsers supporting media queries
      min_width = function (width) {
        return Modernizr.mq('(min-width: ' + width + 'px)');
      };
      max_width = function (width){
         return Modernizr.mq('(max-width: ' + width +'px)');
      };
      min_width_T = function (width) {
        return Modernizr.mq('(min-width: ' + (width+260) + 'px)');
      };
      max_width_T = function (width){
         return Modernizr.mq('(max-width: ' + (width+260) +'px)');
      };
    }
    else {
      // Fallback for browsers that does not support media queries
      min_width = function (width) {
        return $(window).width() >= width;
      };
      max_width = function (width){
           return $(window).width() <= width;
      };
      min_width_T = function (width) {
        return $(window).width()-260 >= width;
      };
      max_width_T = function (width){
           return $(window).width()-260 <= width;
      };
    }

    // Racing static pages navigation menu
    if ($('#categories.leftNavMenuRacing').length > 0) {

      if (max_width(550)) {
        $('.jshowoff').after($('#categories')).after($('.navHeader:contains("Product Categories")')).css('margin-bottom','1em').addClass('menuAfter');
      }

      window.onscroll = function() {
        if (
            (pointsBreak.getWidth() > 550)
            && window.XMLHttpRequest
        ) {
            if (
                document.documentElement.scrollTop > 238
                || self.pageYOffset > 238
            ) {
                var menuOverFlow = ( ($(window).scrollTop()+$('#leftWrap').outerHeight()) - ($('body').outerHeight()) );
                var menuStopPos = $('body').outerHeight()-$('#leftWrap').outerHeight();

                if (menuOverFlow > 0) {
                  $('#leftWrap').removeClass('leftWrapRacingFixed').addClass('leftWrapRacingNormal').css({'top': menuStopPos+'px', 'height':'auto'});
                } else {
                  $('#leftWrap').css({'top': '', 'height': 'auto'}).removeClass('leftWrapRacingNormal').addClass('leftWrapRacingFixed');
                }

            } else if (
                document.documentElement.scrollTop < 238
                || self.pageYOffset < 238
            ) {
                $('#leftWrap').removeClass('leftWrapRacingFixed').addClass('leftWrapRacingNormal');
            }
        }
        else {
            if ($('#leftWrap').hasClass('leftWrapRacingNormal') ) {
                $('#leftWrap').removeClass('leftWrapRacingNormal');
            }
            if ($('#leftWrap').hasClass('leftWrapRacingFixed')) {
                $('#leftWrap').removeClass('leftWrapRacingFixed');
            }
        }
      };

      $(window).on('resize', function() {
        if (max_width(550) && !($('.jshowoff').hasClass('menuAfter'))) {
            $('.jshowoff').after($('#categories')).after($('.navHeader:contains("Product Categories")')).css('margin-bottom','1em').addClass('menuAfter');
        }
        else if (min_width(550) && $('.jshowoff').hasClass('menuAfter')) {
            $('#leftWrap').prepend($('#categories')).prepend($('.navHeader:contains("Product Categories")'));
            $('.jshowoff').removeClass('menuAfter').css('margin-bottom','0px');
        }
        if (pointsBreak.getWidth()<=550) {
            if ($('#leftWrap').hasClass('leftWrapRacingNormal') ) {
                $('#leftWrap').removeClass('leftWrapRacingNormal');
            }
            if($('#leftWrap').hasClass('leftWrapRacingFixed'))
                $('#leftWrap').removeClass('leftWrapRacingFixed');
        }
      });

    }

	var $body = $('body');

	//	Breakpoints
	pointsBreak.init({
		'W<481' : mobileInit,
		'W>480' : mobileTerminate,
		'W>0'   : globalResizr
	});

    // polyfill for trim 
    if(typeof String.prototype.trim !== 'function'){
        String.prototype.trim = function(){
            return this.replace(/^\s+|\s+$/g, '');
        };
    }

	if(!Modernizr.cookies){ alert('Please enable cookies to use this website'); }

    // Test for overflow scrolling on touch devices
	Modernizr.addTest('overflowscrolling', function(){
		return Modernizr.testAllProps('overflowScrolling');
	});
    if(!Modernizr.overflowscrolling){ touchy.overflowFxr('.mobileNav'); }

	// IE viewport fix.
	if(navigator.userAgent.match(/IEMobile\/10\.0/)){$('head').append('<style>@-ms-viewport{width:auto!important}</style>');}

	// Check if prev vehicle is avail & add class
	if(!$('#pvehicle.carSelTgl').length){ $body.addClass('noPrevVehicle'); }

	$.js=function(el){return $('[data-js='+el+']');};

	$('#header-wrapper img').removeAttr('width height');

    // home page banner carousel
    $('#thumbFeatures').jshowoff({
        animatePause: 'false',
        speed: '8000',
        changeSpeed: '1000',
        effect: 'fade'
    });

	//	Hacky iOS/Samsung no next/prev on vehicle selects
	if(touchy.test()){
		$('.vselectwrap').on('focus', 'select', function(e){
			$('select, input').not($(this)).attr('disabled', 'disabled');
			e.stopPropagation();
		});
		$('.vselectwrap').on('blur', 'select', function(e){
			$('select, input').removeAttr('disabled');
			e.stopPropagation();
		});
		$('.vselectwrap').on('change', 'select', function(e){
			$(this).blur();
			e.stopPropagation();
		});
	}

	//	Show/hide nav
    var $bodyWrap = $('.mobileBodyWrap');
	$('.navToggle').on('click', function(){
		//Only allow nav if vehicle has been selected
		if(!$('.mobileNav a + ul').length){
			alert('Please select a vehicle to browse our store');
		}else{
			if(!$body.hasClass('showingNav')){
        $('html, body').css('overflow-y', 'hidden');
		// Use CSS when possible / fallback to js (style.css line 2167ish)
        $body.addClass('showingNav');
        if(!Modernizr.csstransitions){
          $bodyWrap.animate({'margin-left' : '-75%'},500, function(){
            setNavHeight();
          });
        }else{ setNavHeight(); }
			}else{
        $('html, body').css('overflow-y', 'auto');
        if(!Modernizr.csstransitions){ $bodyWrap.css({'height' : '', 'margin-left' : '0'}); }
				$body.removeClass('showingNav');
			}
		}
	});

    // Load the list of subcategories if they were not loaded with the page
    var loadCats = function($category, subcategories){
        var $subcategoryContainer = $category.next('ul'),
            categoryURL = $category.prop('href');
        // if we have no subcategories, go straight to the category URL
        if(!subcategories || subcategories.length === 0){
            location.href = $category.first().prop('href');
        }else{
            // if we have subcategories, insert them into the list before expanding it
            for(var i = 0; i < subcategories.length; i++){
                var $subcategoryItem = $('<li>'),
                    subcategory = subcategories[i],
                    subcategoryURL = '';
                if(categoryURL){ subcategoryURL += categoryURL; }
                subcategoryURL += subcategory.URL;
                $subcategoryItem.append($('<a>').prop('href', subcategoryURL).text(subcategory.subcategory)).appendTo($subcategoryContainer);
            }
            $category.toggleClass('open');
            toggleCats($category);
        }
    };

    var toggleCats = function(theCat){
        theCat.next('ul').slideToggle(100, function(){
            if(theCat.hasClass('open')){
                var scrollSpot = $('.mobileNav').scrollTop() + 75,
                    mySpot = window.innerHeight - $('#header').height() - theCat.position().top;
                if(mySpot <= 85){ $('.mobileNav').animate({'scrollTop': scrollSpot}, 'slow'); }
            }
        });
    };

    var vehicleConfigID = $('#vehicleConfigID').val();
	$('.mobileNav a').on('click', function(e){
        e.preventDefault();
        var $category = $(this);
        // already loaded the categories, just show them
        if($category.next('ul').children().length > 0){
            $category.toggleClass('open');
            toggleCats($category);
        }else{
            $.ajax({
                'url' : '/includes/subcategory.cgi',
                'type' : 'GET',
                'dataType' : 'json',
                'data' : {
                    'vehicleConfigID' : vehicleConfigID,
                    'categoryID' : $category.data('id')
                }
            }).done(function(data){
                loadCats($category, data);
            }).fail(function(){
                loadCats($category);
            });
        }
    });

	// Free Shipping Disclaimer Popup
	freeShippingPopup($('.freeshipping'));

	// Free Shipping Eligible Disclaimer Popup
	freeShippingEligiblePopup($('.freeshippingeligible'));

	// Product Page
	////////////////////////////////////////////
	$('.showRecoverPasswordLink').click(function(){
		$('#recoverPassword').toggleClass('hide');
		$('#defaultPassword').toggleClass('hide');
	});
	$('#showRecoverPasswordLink2').click(function(){
		$('#recoverPassword').toggleClass('hide');
		$('#defaultPassword').toggleClass('hide');
	});
	$('#returnCustLoginLink').click(function(){
		$('#recoverPassword').toggleClass('hide');
		$('#defaultPassword').toggleClass('hide');
	});
	//--------/

    $.js('notify-signup').on('click', function(e){
		e.preventDefault();
		var myStatus,
			theESNum = $(this).attr('href').split('/')[1];
		if($body.hasClass('checkoutpage')){
			myStatus = $(this).parents('.cart-item-content').siblings('.stockstatus').find('.cart-item-stockStatus').text();
		}else{
			myStatus = $(this).parents('.productListBox').find('.stockstatus').text();
		}
		$body.append('<img class="workingFeedback" src="' + CDNpath + '/includes/img/loadingbar-t.gif">');
		$.ajax({
			url:'notify-modal.html',
			type:'GET',
			success: function(data){
				var d = $('<div>').html(data);
				$('.workingFeedback').fadeOut('slow', function(){
					$(this).remove();
					$body.append(d.find('#notifyMeModal'));
					$('#notifyMeModal').fadeIn('slow', function(){
						$(this).before('<div id="notifyModalBg" />');
						$body.on('click', '#notifyModalBg, .closeIt', function(){
							removeModal();
						}).on('click', '#notifyMeSubmit', function(){
							var theEmail = $('#notifyInput').val();
							if(isValidEmailAddress(theEmail)){
								$('#notifyMeModal').fadeOut('slow', function(){
									removeModal();
									$body.append('<img class="workingFeedback" style="display: none;" src="' + CDNpath + '/includes/img/loadingbar-t.gif">');
									$('.workingFeedback').fadeIn('fast', function(){
										notifySignup(theESNum, theEmail, myStatus, d);
									});
								});
							}else{
								alert('Please enter a valid email address');
							}
						});
					});
				});
			}
		});
	});

	$body.on('click', '.hasPopover', function(){
		$(this).next('.popover').attr('data-rel', $(this).attr('id'));
	});
	$body.on('click', '.popClose', function(){
		$('#' + $(this).parents('.popover').data('rel')).trigger('click');
	});

	if($body.hasClass('monthlyFlyers')){
		dynContent.settings = {
			toggles: '.monthListing a',
			closeBtn: '.closeFlyer',
			container: '.copy',
			toLoad: '#flyerContent',
			originalContent: '.indexWrap',
			loadImg: '<img id="loadImg" class="workingFeedback" src="' + CDNpath + '/includes/img/loadingbar-t.gif">',
			speed: 500
		};
		dynContent.init();
	}

	$('#btnRecoverPassword').on('click', function(e){
		return ValidateEmail($('#recoverPasswordEmail').val().trim(), false);
	});

	// simple email validation
	$(".EmailInput").off('blur').on('blur', function(e){
		$(e.target).val($(e.target).val().trim());
		return ValidateEmail($(e.target).val().trim(), true);
	}).closest('form').on('submit', function(e) {
		var val = $(e.target).find('.EmailInput');
		$(val).val($(val).val().trim());
		return ValidateEmail($(val).val().trim(), false);
	});

    $('.listingThumbWrap').each(function(){
        if(!$(this).children('img').length){
            $(this).addClass('noImg');
        }
    });

    /**/
    $('#atwl').on('shown', function(){
        $('.wlistwrapper .wlistimg').each(function(){
            if(!$(this).children('img').attr('src')){
                $(this).children('img').attr('src', CDNpath + '/img/bg_no-image_100x75.jpg');
            }
        });
    });

    if($('.wlDetail')){
        $('.wlDetail .colImgSpt').each(function(){
            if(!$(this).children('.prodNImage').length){
                $(this).append('<div class="prodNImage"><img src="' + CDNpath + '/img/bg_no-image_100x75.jpg" class="dispImg" alt="No Image" title="No Image" ></div>');
            }
        });
    }

    $('.js-login-link, .js-sign-out').on('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        var $this = $(this);

        var $url = $this.attr('href');

        if ( $this.text().match(/out/i) ) { // only clear on logout not login
            try {
                sessionStorage.removeItem('savedForLater');
            } catch (e) {
                // storage not enabled
            }
        }

        window.open($url,"_self");
    });

    !$('#maErrorBox div').text() ? $('#maErrorBox').hide() : $('#maErrorBox').show();

    if($body.hasClass('emailSubscription') && !$('.side-1').children().length){
        $('.side-1').append('<h2 class="drkSubHead">&nbsp;</h2>');
    }
    $body.append('<img src="' + CDNpath + '/img/wait.gif" style="display: none;">');

    $('.rtnTop').on('click', function(e){
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 'fast');
    });

    $("#search-more-button,#mobile-search-more-button").click(function() {
        $("#search-more-menu").slideToggle();
    });
    $("#search-more-menu").mouseleave(function() {
        $("#search-more-menu").hide();
    });

    $("a.btn-addtocart").click(function() {
        $("#placeholder").animate_from_to("#customer-links .cart", {
            'pixels_per_pecond' : 1500,
        });
    });
    $(".pricesave:empty, .pricecut:empty").hide();

    var $categories = $("#categories"),
        bcItems = $(".vehicleheader").children(),
        bcItem = (bcItems[2] || bcItems[1]);
    if($categories.length && bcItem) {
        var $scrollToEl = $categories.find('a:contains("' + $(bcItem).text() + '")').first();
        if($scrollToEl.length) {
            $categories.scrollTop($scrollToEl.offset().top - $categories.offset().top);
        }
    }

    $("#topsearchform").submit(function () {
        var searchBox = $.trim($("#searchBox").val());
        var minimum  ={ number: 2, word: 'two' };

        $('#searchBox').val(searchBox);
        if ($.trim(searchBox).length < minimum.number) {
            alert("Search term is too short. You must search by a minimum of " + minimum.word + " characters.");
            $('#searchBox').val("");
            return false;
        }
    });

    initLightbox();
    checkEmbeds();
    // Give checkEmbeds() a few seconds to prepare embeds before checking lazyYT elements for possible conversion
    setTimeout(setLazyYT, 2000);

    var parentDivs = $('#nestedAccordion div'),
    childDivs = $('#nestedAccordion l3').siblings('div');
    childDivs2 = $('#nestedAccordion l4').siblings('div');
    childDivs3 = $('#nestedAccordion l5').siblings('div');
    $('#nestedAccordion l2').click(function(){
        parentDivs.slideUp();
        toggleNestedAccordian($(this));
    });
    $('#nestedAccordion l3').click(function(){
        childDivs.slideUp();
        toggleNestedAccordian($(this));
    });
    $('#nestedAccordion l4').click(function(){
        childDivs2.slideUp();
        toggleNestedAccordian($(this));
    });
    $('#nestedAccordion l5').click(function(){
        childDivs3.slideUp();
        toggleNestedAccordian($(this));
    });

    $(document).ready(function(){
		setTimeout(initPositions, 1000);
	});
    window.addEventListener('orientationchange', initPositions);
    $( window ).resize( initPositions );


    var mql = window.matchMedia("(min-width: 550px)");
    var mql2 = window.matchMedia("(min-width: 900px)");
    var mql3 = window.matchMedia("(max-width:550px)");
    mql.addListener(handleMediaChange);
    mql2.addListener(fixTextRatio);
    mql3.addListener(fixHeaderBGX);
    fixTextRatio(mql2);
    handleMediaChange(mql);
    fixHeaderBGX(mql3);

    $('.subMenu').click(function(){
        if($('.indicatorT', this).hasClass('open')) {
            $('.indicatorT', this).removeClass('open');
        }
        else {
            $('.indicatorT', this).addClass('open');
        }
    });
    $('#navIcon').click(function(){
        var myElem = $('#nestedAccordion');
        slideToggleElem(myElem, 350);
    });
    $('#contactIcon').click(function(){
        window.location.href="/t-contact";
    });
    $('#accountIcon').click(function(){
        window.location.href="/MyAccount";
    });
    $('#wishlistIcon').click(function(){
        window.location.href="/MyAccount/WishList";
    });
    $("#cartIcon").click(function(){
        window.location.href="/Checkout/";
    });
    $('.leftNavMenu li:not(a)').on('click',function(){
        var newLoc = $(this).find('a').attr('href');
        window.location.href=newLoc;
    });

    // Product Description (dynamic content) expandable content handlers
    $(".colcontent").hide();
	  //toggle the componenet with class msg_body
	$(".colheading").click(function() {
		$(this).next(".colcontent").slideToggle(250);
	});

    var ComponentArt_Storage_PageMenu = []
      , curMenuItemIdx = 0

    // SEOIII-14 Externalize ComponentArt_Storage_PageMenu value
    function accordionElementToComponentArtMenuItem(el, level, parentItemIdx) {
        var $navEl = $(el)
          , menuItemIdx = (curMenuItemIdx ++)
          , navLocation = $navEl.find('a').attr('href')
          , childMenuItemIdxs = []
          , $childNavELs
          , childNavData

        var menuItemAttrs = [
            [30, $navEl.text().trim()]
        ];

        if (!navLocation) {
            navLocation = $navEl.data('location');
        }

        if (navLocation) {
            menuItemAttrs.push([17, navLocation]);
        }

        if (level == 1) {
            menuItemAttrs.push([40, 'TopItemLook']);
        }

        if (level < 2) {
            $childNavELs = $navEl.next('div').children('l' + (level + 2));
        } else {
            $childNavELs = $navEl.next('div').find('li');
            if ($childNavELs.length == 0) {
                childNavData = $navEl.next('div').data('menu-children');
            }
        }

        ComponentArt_Storage_PageMenu.push([
            'p' + menuItemIdx,
            parentItemIdx,
            childMenuItemIdxs,
            menuItemAttrs,
        ]);

        var hasChildren = false;

        if ($childNavELs && $childNavELs.length > 0) {
            hasChildren = true;
            $childNavELs.each(function(i, el) {
                childMenuItemIdxs.push(accordionElementToComponentArtMenuItem(el, (level + 1), menuItemIdx));
            });
        } else if (childNavData && childNavData.length > 0) {
            hasChildren = true;
            $.each(childNavData, function(i, data) {
                childMenuItemIdxs.push(menuItemDataToComponentArtMenuItem(data, (level + 1), menuItemIdx));
            });
        }

        if (hasChildren && level > 1) {
            menuItemAttrs.push(
                ["Look-RightIconUrl","arrow.gif"],
                ["Look-RightIconWidth","15"]
            );
        }

        return menuItemIdx;
    }

    function menuItemDataToComponentArtMenuItem(menuItemData, level, parentItemIdx) {
        var menuItemIdx = (curMenuItemIdx ++)
          , childMenuItemIdxs = []

        var menuItemAttrs = [
            [30, menuItemData.label]
        ];

        if (menuItemData.URL) {
            menuItemAttrs.push([17, menuItemData.URL]);
        }

        ComponentArt_Storage_PageMenu.push([
            'p' + menuItemIdx,
            parentItemIdx,
            childMenuItemIdxs,
            menuItemAttrs,
        ]);

        if (menuItemData.children && menuItemData.children.length > 0) {

            menuItemAttrs.push(
                ["Look-RightIconUrl","arrow.gif"],
                ["Look-RightIconWidth","15"]
            );

            $.each(menuItemData.children, function(i, data) {
                childMenuItemIdxs.push(menuItemDataToComponentArtMenuItem(data, (level + 1), menuItemIdx));
            });

        }

        return menuItemIdx;
    }

    var $srcDataEl = $('#nestedAccordion l2');
    if ($srcDataEl.length > 0) {

        $('#nestedAccordion l2').each(function(i, el) {
            accordionElementToComponentArtMenuItem(el, 1, -1);
        });

        /* Menu Setup */
        window.ComponentArt_ItemLooks_PageMenu=[[0,'DefaultItemLook',1,'MenuItem',2,'MenuItemHover',5,2,6,5,7,15,8,2,9,'MenuItemDown',10,'MenuItemDown',27,0,28,0],[0,'TopItemLook',1,'TopMenuItem',2,'TopMenuItemHover',5,2,6,4,7,4,8,2,27,0,28,0],[0,'ScrollUpItemLook',1,'ScrollItem',2,'ScrollItemH',3,13,4,15,9,'ScrollItemA',23,'scroll_up.gif',27,0,28,0],[0,'ScrollDownItemLook',1,'ScrollItem',2,'ScrollItemH',3,13,4,15,9,'ScrollItemA',23,'scroll_down.gif',27,0,28,0],[0,'BreakItem',3,1,4,'100%',23,'break.gif',27,0,28,0]];
        window.ComponentArt_ScrollLooks_PageMenu=[[0,'ScrollDownItemLook'],[0,'ScrollUpItemLook']];

        window.ComponentArt_Init_PageMenu = function() {
            if (!(window.cart_menu_kernel_loaded && window.cart_menu_support_loaded)) {
                setTimeout('ComponentArt_Init_PageMenu()', 500);
                return;
            }

            if (!(window.cart_menu_documentmousedownhandled)) {
                ComponentArt_AddEventHandler(document,'mousedown',new Function('event','ComponentArt_Menu_DocumentMouseDown(event)'));
                window.cart_menu_documentmousedownhandled = true;
            }

            window.PageMenu = new ComponentArt_Menu('PageMenu',ComponentArt_Storage_PageMenu,ComponentArt_ItemLooks_PageMenu,ComponentArt_ScrollLooks_PageMenu,null,false);
            PageMenu.Postback = function() { __doPostBack('PageMenu','') };
            PageMenu.PropertyStorageArray = [
                ['ApplicationPath','/'],
                ['AutoPostBackOnSelect',false],
                ['AutoPostBackOnCheckChanged',false],
                ['BaseUrl',''],
                ['CascadeCollapse',false],
                ['ClientEvents',null],
                ['ClientSideOnContextMenuHide',null],
                ['ClientSideOnContextMenuShow',null],
                ['ClientSideOnItemMouseOut',null],
                ['ClientSideOnItemMouseOver',null],
                ['ClientSideOnItemSelect',null],
                ['ClientTemplates',[]],
                ['CollapseDelay',0],
                ['CollapseDuration',200],
                ['CollapseSlide',0],
                ['CollapseTransition',0],
                ['CollapseTransitionCustomFilter',null],
                ['ContextControlId',null],
                ['ContextData',null],
                ['ContextMenu',0],
                ['ControlId','PageMenu'],
                ['CssClass','TopMenuGroup'],
                ['DefaultChildSelectedItemLookId',''],
                ['DefaultDisabledItemLookId',''],
                ['DefaultGroupCssClass','MenuGroup'],
                ['DefaultGroupExpandDirection',0],
                ['DefaultGroupExpandOffsetX',0],
                ['DefaultGroupExpandOffsetY',0],
                ['DefaultGroupHeight',null],
                ['DefaultGroupItemSpacing',1],
                ['DefaultGroupOrientation',0],
                ['DefaultGroupWidth',null],
                ['DefaultItemLookId','DefaultItemLook'],
                ['DefaultItemTextAlign',0],
                ['DefaultItemTextWrap',false],
                ['DefaultSelectedItemLookId',''],
                ['DefaultTarget',''],
                ['ExpandDelay',0],
                ['ExpandDisabledItems',true],
                ['ExpandDuration',0],
                ['ExpandOnClick',false],
                ['ExpandSlide',0],
                ['ExpandTransition',0],
                ['ExpandTransitionCustomFilter',null],
                ['ForceHighlightedItemID',''],
                ['Height',null],
                ['HideSelectElements',cart_browser_hideselects && true],
                ['HighlightExpandedPath',true],
                ['ImagesBaseUrl','/includes/img/'],
                ['MultiPageId',null],
                ['Orientation',1],
                ['OverlayWindowedElements',cart_browser_overlays && true],
                ['PlaceHolderId','PageMenu'],
                ['ScrollingEnabled',true],
                ['SelectedItemPostBackID','p0'],
                ['ShadowColor','#8D8F95'],
                ['ShadowEnabled',true],
                ['ShadowOffset',2],
                ['TopGroupExpandDirection',0],
                ['TopGroupExpandOffsetX',0],
                ['TopGroupExpandOffsetY',0],
                ['TopGroupItemSpacing',1],
                ['Width',null],
            ];
            PageMenu.LoadProperties();
            ComponentArt_Menu_MarkSelectedItem(PageMenu);
            ComponentArt_Menu_MarkForceHighlightedItem(PageMenu);
            PageMenu.Initialize();
            ComponentArt_Menu_RenderMenu(PageMenu);
            // ComponentArt_Menu_InitKeyboard(PageMenu);
            window.PageMenu_loaded = true;
        };

        ComponentArt_Init_PageMenu();
    }

    $('.btn-vehicle-reset, #ClearSectionImageButton, .fullCatalogButton').on('click', function () {
        window.location = '/vehicleReset';
    });

  // Search Results Page
  if ($('body').hasClass('searchResults')) {

    $('#SearchTerm').on("input", function(e) {
        if (event.keyCode == 13) {
            e.preventDefault();
            $("#form1").submit();
            return false;
        }
        return false;
    });

    $("#form1").on("submit", function (e) {
        var minimum = { number: 2, word: 'two' };
        if ($.trim($("#SearchTerm").val()).length < minimum.number) {
            alert("Search term is too short. You must search by a minimum of " + minimum.word + " characters.");
            $('#SearchTerm').val("");
            return false;
        }
        else {
            e.preventDefault();
            document.cookie='search_url='+window.location.pathname+';path=/';
            var action = '/Search';
            var searchTerm = $.trim($("#SearchTerm").val());
            action = action + '?SearchTerm=' + encodeURIComponent(searchTerm).replace(/%20/g, '+');
            action = action + '&ResultPage=' + $("#ResultPage").val();
            action = action + '&SortBy=' + $("#SortingDropDownList").val();
            action = action + '&ResultCount=' + $("#ResultCountDropDownList").val();
            window.location.href = action;
            return false;
        }
    });

    $('#ResultCountDropDownList').val(searchResultCountDropDownList);
    $('#SortingDropDownList').val(searchSortingDropDownList);

    $('#SectionDropDownList').on('change', function () {
        var selected = $(this).find('option:selected');
        var extra = selected.data('url');
        var redirectURL = window.location.href.replace(/ResultPage=\d+/, 'ResultPage=0');
        $.get('/setVehicleGroup', {ShortURL: extra}, function() {
            window.location.href = redirectURL;
        });
    });

    var noVehicleImageURL = CDNpath + '/images/Turner-Default-Chassis.png';
    var imageurl = noVehicleImageURL;
    if (window.selectedVehicleGroupIconURL) {
        imageurl = CDNpath + window.selectedVehicleGroupIconURL;
    }
    // $('#SectionImage').attr('src', imageurl);
    // $('#SectionImage').error(function() {
    //     $('#SectionImage').attr('src', noVehicleImageURL);
    // });

    var thisPage = $("#thisPage").val();
    $('#previousPage').on('click', function (e) {
        var currentURL = window.location.href;
        var re = /ResultPage=(\d+)/;
        var newpage = parseInt(thisPage) - 1;
        var newURL = currentURL.replace(re, 'ResultPage=' + newpage);
        window.location.href = newURL;
        e.preventDefault();
    });

    $('#nextPage').on('click', function (e) {
        var currentURL = window.location.href;
        var re = /ResultPage=(\d+)/;
        var newpage = parseInt(thisPage) + 1;
        var newURL = '';
        if(currentURL.includes('ResultPage')){
            newURL = currentURL.replace(re, 'ResultPage=' + newpage);
        } else{
            newURL = currentURL + '&ResultPage=' + newpage;
        }
        window.location.href = newURL;
        e.preventDefault();
    });

    setTimeout(function(){
        $('.js-lazyYT').closest('td').css('display','inline-block');

    },1500);
    $(window).on('lazyTYLoaded', function(e){
        $('.js-lazyYT').closest('td').css('display','inline-block');
    });

  }

  // Brand Page
  if ($('meta[name="page-template"]').attr('content') == 'brandPage.html') {

    var thisPage = $("#thisPage").val()

    $('.previousPage').on('click', function (e) {
        var currentURL = window.location.href;
        var re = /resultpage=(\d+)/;
        var newpage = parseInt(thisPage) - 1;
        var newURL;
        if (currentURL.match(re, 'resultpage=' + newpage)){
            newURL = currentURL.replace(re, 'resultpage=' + newpage);
        }
        else{
            newURL = currentURL+'?resultpage=' + newpage;
        }
        window.location.href = newURL;
        e.preventDefault();
    });

    $('.nextPage').on('click', function (e) {
        var currentURL = window.location.href;
        var re = /resultpage=(\d+)/;
        var newpage = parseInt(thisPage) + 1;
        var newURL;
        if (currentURL.match(re, 'resultpage=' + newpage)){
            newURL = currentURL.replace(re, 'resultpage=' + newpage);
        }
        else{
            newURL = currentURL+'?resultpage=' + newpage;
        }
        window.location.href = newURL;
        e.preventDefault();
    });

  }

  // siteVehicleSelector
  (function() {

    var onProductPage = $('body').hasClass('bodyProduct')
      , chatSelector = false
      , vSelectDone = false
      , $vSelectWrap = $('.vehicleNavSelectWrap').not('#select-vehicle-modal .vehicleNavSelectWrap, .chatVehicleSelector')
      , $vSelectWrapChat

    $('.vehicleNavSelectWrap').each(function(i,myElem){
        if ($(myElem).parents('.chatClient').length > 0) {
            chatSelector = true;
            $(myElem).addClass('chatVehicleSelector');
            $vSelectWrapChat = $(myElem);
        }
    });

    var initSelectSteps = siteInitSelectSteps.slice(0),
        refreshOnComplete = siteRefreshOnCompleteVehicle,
        initing = 1,
        $initVStepSelects = $vSelectWrap.find('.vehicleNavStep');

    function init() {

        $initVStepSelects.change(function() {
            categoryVStepChanged($(this));
        });

        var makeSelection = initSelectSteps.shift();
        if (makeSelection) {
            var $makeSelect = $initVStepSelects.first();
            $makeSelect.val(makeSelection);
            categoryVStepChanged($makeSelect, initSelectSteps);
        }
    }

    function categoryVStepChanged($stepSelectChanged, selectNextSteps) {
        vSelectLastChanged = false;

        var stepNumChanged = $stepSelectChanged.attr('data-vstep'),
            newValue = $stepSelectChanged.val();
        $stepSelectChanged.nextAll('.vehicleNavStep').remove();

        if (!newValue) {
            return;
        }

        if (!selectNextSteps) {
            initing = 0;
        }

        var data = {
            'initing' : initing,
            'currentPageURL' : currentPageURL,
        };

        if (chatSelector) {
            data.chatForm = 'yes';
        }

        data['vstep_'+stepNumChanged] = newValue;

        $stepSelectChanged.prevAll('.vehicleNavStep').each(function(i, prevStepSelect) {
            var $prevStepSelect = $(prevStepSelect),
                selectedValue = $prevStepSelect.val();

            if (!selectedValue)
                return;

            data['vstep_'+$prevStepSelect.attr('data-vstep')] = selectedValue;
        });

        $('img.loading').removeClass('hidden');

        $.get('/vehicleSelectorOptions', data, function(response) {

            $('img.loading').after('<div id="vSelectedLabel"></div>');

            if (
                !onProductPage
                && typeof(response['newLocation']) == 'string'
            ) {

                if (refreshOnComplete) {
                    var re = /ResultPage=(\d+)/;
                    window.location.href = window.location.href.replace(re, 'ResultPage=0');
                } else {
                    window.location.href = response['newLocation'];
                }

                return;
            }

            if (response['steps']) {
                $('img.loading').addClass('hidden');
                $('p.doesNotFit').addClass('hidden');
                $('p.doesFit').addClass('hidden');
                $('p.alineFit').addClass('hidden');
                var numStepsData = response['steps'].length;

                $.each(response['steps'], function(i, stepData) {
                    var $newStep = addCategoryVStep(stepData),
                        stepSelection;

                    if (selectNextSteps)
                        stepSelection = selectNextSteps.shift();

                    if (stepSelection) {
                        $newStep.val(stepSelection);
                        if (numStepsData == (i+1))
                            categoryVStepChanged($newStep, selectNextSteps);
                    }

                });
                    if(response['steps'].length){
                        $('#vSelectedLabel').append($('.vehicleNavStep').last().val());
                    }
            }
            if (
                onProductPage
                && (!(response['steps']) || response['steps'].length == 0)
            ) {
                if (!vSelectLastChanged) {
                    $('.vehicleNavStep').not('#select-vehicle-modal .vehicleNavSelectWrap').last().trigger('change');
                    vSelectLastChanged = true;
                } else {
                    checkProductFitsVehicle();
                }
            }
            if (response['chatForm'] == 'yes') {
                $('img.loading').addClass('hidden');
                $('#vSelectedLabel').append($('.vehicleNavStep').last().val());
            }
            if (response['error']) {
                alert('Vehicle Selection Error: '+response['error']);
                $('img.loading').addClass('hidden');
            }

        });
    }

    function addCategoryVStep(stepData) {
        var $newStep = $initVStepSelects.first().clone(true).attr('data-vstep', stepData.stepNum),
            options = [
                '<option value="">'+stepData.label+'</option>'
            ];

        $.each(stepData.options, function(i, option) {
            options.push('<option value="'+option.value+'">'+option.label+'</option>')
        });

        $newStep.html(options.join("\n"));

        $vSelectWrap.append($newStep);

        if (stepData.options.length == 1)
            $newStep.val(stepData.options[0].value);

        return $newStep;
    }

    init();
  }());

  // Chat Vehicle Selector
  (function() {
    var chatSelector = false
      , vSelectDone = false
      , $vSelectWrap
      , $vSelectWrapChat

    $('.chatVehicleSelector').each(function(i,myElem){
        if ($(myElem).parents('.chatClient').length > 0) {
            chatSelector = true;
            $vSelectWrapChat = $(myElem);
        }
    });

    if ($('.chatVehicleSelector').length > 1) {
        $vSelectWrap = $('.chatVehicleSelector').not('#select-vehicle-modal .chatVehicleSelector, .chatVehicleSelector');    // isolate chat vehicle selector when present
    } else {
        $vSelectWrap = $('.chatVehicleSelector').not('#select-vehicle-modal .chatVehicleSelector');
    }

    var initSelectSteps = chatInitSelectSteps.slice(0),
        initing = 1,
        finalInit = 0,
        $initVStepSelects = $vSelectWrap.find('.vehicleNavStep');

    function init() {
        $initVStepSelects.change(function() {
            categoryVStepChanged($(this));
        });

        var makeSelection = initSelectSteps.shift();
        if (makeSelection) {
            var $makeSelect = $initVStepSelects.first();
            $makeSelect.val(makeSelection);
            categoryVStepChanged($makeSelect, initSelectSteps);
        }
    }

    function categoryVStepChanged($stepSelectChanged, selectNextSteps) {
        vSelectLastChanged = false;

        var stepNumChanged = $stepSelectChanged.attr('data-vstep'),
            newValue = $stepSelectChanged.val();
        $stepSelectChanged.nextAll('.vehicleNavStep').remove();

        if (!newValue) {
            return;
        }

        if (!selectNextSteps) {
            initing = 0;
        }

        var data = {
            'initing' : initing,
            'currentPageURL' : currentPageURL,
        };
        if (chatSelector) {
            data.chatForm = 'yes';
        }
        data['vstep_'+stepNumChanged] = newValue;

        $stepSelectChanged.prevAll('.vehicleNavStep').each(function(i, prevStepSelect) {
            var $prevStepSelect = $(prevStepSelect),
                selectedValue = $prevStepSelect.val();

            if (!selectedValue)
                return;

            data['vstep_'+$prevStepSelect.attr('data-vstep')] = selectedValue;
        });

        $('img.loading').removeClass('hidden');

        $.get('/vehicleSelectorOptions', data, function(response) {

            $('img.loading').after('<div id="vSelectedLabel"></div>');

            if (response['steps']) {

                $('img.loading').addClass('hidden');
                $('p.doesNotFit').addClass('hidden');
                $('p.doesFit').addClass('hidden');

                var numStepsData = response['steps'].length;

                $.each(response['steps'], function(i, stepData) {
                    var $newStep = addCategoryVStep(stepData),
                        stepSelection;

                    if (selectNextSteps) {
                        stepSelection = selectNextSteps.shift();
                    }

                    if (stepSelection) {
                        $newStep.val(stepSelection);
                        if (numStepsData == (i+1)) {
                            categoryVStepChanged($newStep, selectNextSteps);
                        }
                    }

                });

                if (response['steps'].length) {
                    $('#vSelectedLabel').append($('.vehicleNavStep').last().val());
                } else if (!finalInit) {
                    finalInit = 1;
                    $('.chatVehicleSelector .vehicleNavStep').last().trigger('change');
                }

                // if selecting within Live Chat form
                if ($stepSelectChanged.parents('#contentform.LCForm').length > 0) {
                    setChatSelectedVehicleConfigID();
                }
            }

            if (response['chatForm'] == 'yes') {
                $('img.loading').addClass('hidden');
                $('#vSelectedLabel').append($('.vehicleNavStep').last().val());
                setChatSelectedVehicleConfigID(response['vehicleConfigID']);
            }
            if (response['error']) {
                alert('Vehicle Selection Error: '+response['error']);
                $('img.loading').addClass('hidden');
            }

        });
    }

    function addCategoryVStep(stepData) {
        var $newStep = $initVStepSelects.first().clone(true).attr('data-vstep', stepData.stepNum),
            options = [
                '<option value="">'+stepData.label+'</option>'
            ];

        $.each(stepData.options, function(i, option) {
            options.push('<option value="'+option.value+'">'+option.label+'</option>')
        });

        $newStep.html(options.join("\n"));

        $vSelectWrap.append($newStep);

        if (stepData.options.length == 1)
            $newStep.val(stepData.options[0].value);
        $newStep.attr('name', 'vstep_' + stepData.stepNum );
        return $newStep;
    }

    init();
  }());

});

function initLightbox() {
    $('[rel^="lightbox"]').each(function(i,myElem){
        var mySrc = $(myElem).attr('href');
        if(!mySrc.match(/^http/)) {
            mySrc = CDNpath + mySrc;
        }
        else {
            var lbRegEx = /(^(http|https)(:\/\/)(www.turnermotorsport.com))/gi;
            var myMatch = mySrc.match(lbRegEx);
            if(myMatch) {
                mySrc = mySrc.replace(myMatch[0], CDNpath);
            }
        }
        $(myElem).attr('href',mySrc);
    }).lightbox();
}

function objToLazyYT(obj,ytID, vidWidth, vidHeight, cb){
    var $myObj = $(obj);
    // Don't go greater than 300 width and 200 height to keep containers responsive.
    var height = vidHeight < 200 ? vidHeight : '200';
    var width = vidWidth < 300 ? vidWidth : '300';
    $myObj.replaceWith('<div class="js-lazyYT" data-youtube-id="'+ytID+'" data-width="'+width+'" data-height="'+height+'" data-desc="true"></div>');

    if(typeof cb === "function") cb($myObj);
}

// Make youtube embeds part of product descriptions mobile friendly, convert to lazyYT format used elsewhere.
function checkEmbeds() {
    $('.ObjectDescPanel iframe, .TMSR_ProductContentCell iframe, .productlongdesc iframe').each(function(i,myElem){
        var ytCheck = /(?:youtube\.com\/embed\/)([^#\&\?]*)/;
        var ytMatch = $(myElem).attr('src').match(ytCheck);
        if(ytMatch) {
            var vidW = $(myElem).attr('width')< 240 ? $(myElem).attr('width') : '240';
            var vidH  = $(myElem).attr('height') < 160 ? $(myElem).attr('height') : '160';
            objToLazyYT(myElem,ytMatch[1],vidW,vidH,function(myObj){
                if($(myObj).parent().css('float','right')
                    // html5 embeds with parent css having float:right gets hidden
                    &&(!($(myObj).parent().is('.ObjectDescPanel, .TMSR_ProductContentCell, .productlongdesc')))
                    ) {
                    $(myObj).parent().css('float','none');
                }
                $('.js-lazyYT').trigger('lazyTYLoaded');
            });
        }
    });
    //check objects next
    $('.ObjectDescPanel object, .TMSR_ProductContentCell object, .productlongdesc object').each(function(i,myElem){
        var ytCheck = /(?:youtube.com\/v\/)([^#\&\?]*)/;
        // todo, extend check to carry width/height
        //var ytCheck = /(?:youtube.com\/v\/)([^#\&\?]*)(?:.*)(?:width=?)(?:"|'?)([0-9+])(?:"|'?)(?:.*)(?:height=)(?:"|'?)([0-9]+)(?:"|'?)/;
        var ytMatch = $(myElem).find('param').attr('value').match(ytCheck);
        if(ytMatch) {
            objToLazyYT(myElem,ytMatch[1],ytMatch[2],ytMatch[3],function(myObj){
                if($(myObj).parent().css('float','right')
                    // html5 embeds with parent css having float:right gets hidden
                    &&(!($(myObj).parent().is('.ObjectDescPanel, .TMSR_ProductContentCell, .productlongdesc')))
                    ) {
                    $(myObj).parent().css('float','none');
                }
                $('.js-lazyYT').trigger('lazyTYLoaded');
            });
        }
    });
}

function setLazyYT() {
    $('.js-lazyYT').each(function(i,myElem){
        // pass prodDesc flag to force inherited width/height settings.
        if($(myElem).data('desc')) {
            $(myElem).lazyYT({prodDesc:true});
        }

        if($(myElem).parent().css('float','right')
            &&(!($(myElem).parent().is('.ObjectDescPanel, .TMSR_ProductContentCell, .productlongdesc')))
            ) {
            $(myElem).parent().css('float','none');
        }
    });

    setTimeout(function() {
        $(window).trigger('lazyTYLoaded');
        $('.js-lazyYT').addClass('lazyYTLoaded');
    }, 1000);
}

function slideToggleElem(myElem, mySpeed) {
    if( $(myElem).hasClass('open')) {
        $(myElem).removeClass('open').addClass('close');
        $(myElem).animate({height:'toggle'},mySpeed);
    }
    else {
        if($(myElem).hasClass('close')) {
            $(myElem).removeClass('close').addClass('open');
            $(myElem).animate({height:'toggle'},mySpeed);
        }
        else {
            // For first time toggle, do a hidden minimize
            $(myElem).animate({height:'toggle'},mySpeed);
            //$(myElem).animate({height:'toggle'},10000);
            $(myElem).addClass('open').show();
        }
    }
}

function toggleNestedAccordian($rowClicked) {
    var $togglee = $rowClicked.next('div');

    if (!$togglee.length) return;

    if ($togglee.is(':hidden')) $togglee.slideDown();
    else                        $togglee.slideUp();
}

function initPositions() {
    density = window.devicePixelRatio;

    if((density>1)&&(window-innerWidth<550)) {
        $('#categories li').css('font-size', density+'em').css('height', density+'em');
        $('#navHeader').css('font-size', (density*1.5)+'em');
    }

    var myWidth=window.innerWidth;
    if(window.innerWidth>1370) {
        $('#header_bg_x').css('width','562px').css('display','inline-block');
    }
    else if(window.innerWidth>1280) {
        $('#header_bg_x').css('width',(window.innerWidth-815)+'px').css('display','inline-block');
    }
    else if(window.innerWidth>1200) {
        $('#header_bg_x').css('width',(myWidth-810)+'px').css('display','inline-block');
    }
    else if(window.innerWidth>788) {
        $('#header_bg_x').css('width',(myWidth-783-(( myWidth*myWidth / ( 788 * 788) )*7))+'px').css('display','inline-block');
    }
    else if(window.innerWidth<=788) {
        $('#header_bg_x').css('display','none');
    }
    if(window.innerWidth<900) {
        if(window.innerWidth>550) {
            $('.TopMenuItem' ).css('font-size', function(){
                var textRatio =  (window.innerWidth/900)*(900/700) ;
                return textRatio.toFixed(2)+'em';
            });
            $('#horizNav2 ul.tameHoriz li' ).css('font-size', function(){
                var textRatio = window.innerWidth / 900;
                return textRatio.toFixed(2)+'em';
            });
            $('#horizNav2 ul.tameHoriz li span.pipe').css('padding',function(){
                var Ratio = window.innerWidth / 1700;
                return Ratio.toFixed(2)+'em';
            });
        }
        else {
            $('#horizNav2 ul.tameHoriz li' ).css('font-size', '.75em');
        }
        $('#QueryResultsPanel').css('max-width',$(window).innerWidth()-30+'px');
    }

    if(window.innerWidth < 932) fixFBPost();
}

function fixFBPost() {
    $(".fb-post iframe").attr({"width":'','height':''});

    if(window.innerWidth<550) {
        $(".fb-post span, .fb-post iframe").css({
            'width' : '100%',
            'max-width' : '550px',
            'height' : parseInt(window.innerWidth*1.35) +'px'}
        );
    }
    else {
        $(".fb-post span, .fb-post iframe").css({
            'width' : '100%',
            'max-width' : '550px',
            'height' : parseInt(window.innerWidth * .3) +'px'
        });
    }
}

function handleMediaChange(mediaQueryList) {
    if (mediaQueryList.matches) {
        // The browser window is at least 550px wide, close mobile nav and show search bar.
        if($('#nestedAccordion').hasClass('open')) {
            slideToggleElem($('#nestedAccordion'),0);
        }
        if($('#horizNav2').hasClass('close')) {
            slideToggleElem($('#horizNav2'),0);
        }
    }
    else {
        // The browser window is less than 550px wide, keep searchbar closed by default unless clicked.
        if($('#horizNav2').hasClass('open')) {
            slideToggleElem($('#horizNav2'),0);
        }
    }
}

function fixTextRatio(mediaQueryList) {
    if (mediaQueryList.matches) {
        // The browser window is at least 900px wide.
        $('.TopMenuItem').css('font-size', '14px');
        $('#horizNav2 ul.tameHoriz li').css('font-size', '1em');
        $('#horizNav2 ul.tameHoriz li span.pipe').css('padding', '1em');
    }
}

function fixHeaderBGX(mediaQueryList) {
    if(mediaQueryList.matches) {
        $('#header_bg_x').css('display', 'none');
    }
}

function imageExists(url, callback) {
    var img = new Image();
    $(img).on('load',  function() {
        var myWidth = this.width;
        var myHeight = this.height;
        callback(true, myWidth, myHeight);
    });
    $(img).on('error', function() {
        callback(false);
    });
    img.src = url;
}

function listenSnap(){
	$("#snapChatQR").animate({"top" : "+=15px"},300,fixSnapModal());

	window.addEventListener('resize',fixSnapModal, true);
	window.addEventListener('scroll', fixSnapModal, true);
}
function quietSnap(){
	$("#snapChatQR").animate({"top" : "-=15px"},200,fixSnapModal());
	window.removeEventListener('resize',fixSnapModal, true);
	window.removeEventListener('scroll',fixSnapModal, true);
}

// fix snapchat modal to be centered and fit on all sizes responsively.
var fixSnapModal= function(){
	var w=window.innerWidth;
	var h=window.innerHeight;
	var mq = window.matchMedia("screen and (orientation:landscape) and (max-width:943px)");
	var mq2 = window.matchMedia("screen and (orientation:landscape) and (max-height:620px)");
	snapW=$("#snapChatQR").width();
	var topDoc = (document.documentElement.scrollTop || document.body.scrollTop);
	$("#snapChatQR").css("top",topDoc+Math.floor(.02*h)+"px");
	if((snapW>=858)){
		$("#snapChatQR").css("left",Math.floor(((w-898)/2-(.1*w)))+"px");
	}
	else if((snapW>=398)&&(mq2.matches)){
		$("#snapChatQR").css("left",Math.floor(((w-398)/2-(.1*w)))+"px");
	}
	else {
		$("#snapChatQR").css({"left": "0%", "margin": "0% 10% 0% 10%"});
	}
};

async function addToCart(tmsProductID, extraParams) {
    var cf = window.confirmFitment;
    if ( cf && ! cf.fitmentConfirmed ) {
        if ( cf.setProductID( tmsProductID ) ) {
            cf.show();
            return false;
        }
    }

    // Fix for checkoutv2. This function is being called when adding to cart from wishlist,
    // However the #qty<tmsid> stuff was changed. We look for checkoutv2's input qty first then
    // fall back for v1 if needed.
    var inQty = 1;
    var $v2Input = $('input[name="qty_box1_'+tmsProductID+'"]');
    if($v2Input.val() > 0) {
        inQty = (parseInt($v2Input.val()) || 1);
    } else {
        inQty = (parseInt($('#qty'+tmsProductID).val()) || 1);
    }
    var cartParams = {
        'add1' : tmsProductID,
        'qty1' : inQty
    };

	var count = 1;
	var $qtys = $("input.pdksuggest");
	if ($qtys.length) {
		$qtys.each(function() {
			if ($(this).is(':checked')) {
				count++;
				cartParams['add' + count] = $(this).data("tmsproductid");
				cartParams['qty' + count] = 1;
			}
		});
	}

	if (extraParams)
		$.extend(cartParams, extraParams);

    if ( window.useMiniCart ) {
        cartParams.miniCart = 1;
    }

    var url = (
		'/Cart/?'
		+ $.map(cartParams, function(v, k) {
			return k + '=' + v
		}).join('&')
	);

    if ( !window.useMiniCart ) {
        window.location.href = url;
        return;
    }

    const fetchCart = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log( 'Error:', err );
            return error;
        });

    return fetchCart;
}

window.dispatchEvent(new Event('atcReady'));

function clearOtherQtys(tmsProductID) {
    $('.qtyInput').each(function(i,myElem){
        if($(myElem).attr('id')!=('qty'+tmsProductID)) {
            $(myElem).prop('value', '');
        }
    });
}

function qsToObject(qs) {
    var search = qs.substring(1);
    if (search.indexOf('&') == 0) {
        search = search.substring(1);
    }
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
}

function fixNavState(navState, removeParams, addParams) {
    if (removeParams || addParams) {
        var urlParts = navState.split('?');
        if (urlParts[1] || addParams) {
            var params = {};
            if (urlParts[1])
            	params = qsToObject('?'+urlParts[1]);
			if (removeParams)
				$.each(removeParams, function(i, param) {
					delete params[param];
				});
			if (addParams)
				$.each(Object.keys(addParams), function(i, param) {
					params[param] = addParams[param];
				});
            $.each(Object.keys(params), function(i, param) {
                params[param] = params[param].replace(/\+/g, ' ');
            });
            navState = urlParts[0] + '?' + $.param(params);
        }
    }

    // Prepend "/" for PATH_INFO if no PATH_INFO specified
    if (navState.substr(0,1) != '/' && !(navState.substr(0,1) == '?' && navState.length > 1)) {
        navState = '/' + navState;
    }
    // if path starts with ?, prepend current url path so that getJSON works correctly
    if (navState.substr(0,1) == '?') {
       navState = window.location.pathname + navState;
    }

    var parser = document.createElement('a');
    parser.href = navState;
    // Append trailing slash if missing
    if (
        !parser.pathname.match(/\.(cgi|xml)$/)
        && !parser.pathname.match(/\/$/)
    ) {
        navState = navState.replace(/([^\/]?)(\?|#|$)/, '$1/$2');
    }

    // strip vehicle selector from start of URL
    navState = navState.replace( new RegExp( "^/(?:BMW|Mini)-?.*?(/|\\?|$)" ), "/$1" );
    navState = navState.replace( new RegExp( "//", "g" ), "/" );

    // remove initial slash if there is nothing else in the path
    navState = navState.replace( new RegExp( "^/(|\\?.*)$" ), "$1" );

    // add vehicleGroup URL to beginning if applicable
    if( window.selectedVehicleGroupURL
        && !RegExp( "^/Cart/" ).test(navState)
    ) {
        navState = "/" + window.selectedVehicleGroupURL + navState;
    }

    // remove final '?'
    navState = navState.replace(/\?$/, '');

    return navState;
}

function validateUserPriceFields(priceRangeForm) {

    var minPrice,finalMin,maxPrice,finalMax;
    minPrice = finalMin = Math.abs(parseInt(priceRangeForm["userSalesPriceMin"].value,10));
    maxPrice = finalMax = Math.abs(parseInt(priceRangeForm["userSalesPriceMax"].value,10));
    if (minPrice > maxPrice) {
        finalMin = maxPrice;
        finalMax = minPrice;
    }
    priceRangeForm["userSalesPriceMin"].value = finalMin;
    priceRangeForm["userSalesPriceMax"].value = finalMax;
    return 1;
}

function setupPasswordFields (passwordSel, confirmPasswordSel) {
		
	var $password = (passwordSel !== undefined) ? $(passwordSel) : '',
		$confirmPassword = (confirmPasswordSel !== undefined) ? $(confirmPasswordSel) : '',
		pattern = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,128}', // note: need \\ instead of \
		regexMsg = 'Passwords must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (! @ # $ % ^ & *) and be between 8-128 characters in length.',
		minlength = '8',
		maxlength = '128';

	var setErrorMsg = function(e) {
		var errorMsg = '';
		if (e.target.validity.patternMismatch) {
			errorMsg = regexMsg;
		}
		e.target.setCustomValidity(errorMsg);
	}

	if ($password) {
		$password.attr('pattern', pattern);
		$password.attr('minlength', minlength);
		$password.attr('maxlength', maxlength);
		$password.on('invalid', setErrorMsg);
		$password.on('input', setErrorMsg);
		$password.on('change', setErrorMsg);
	}
	if ($confirmPassword) {
		$confirmPassword.attr('pattern', pattern);
		$confirmPassword.attr('minlength', minlength);
		$confirmPassword.attr('maxlength', maxlength);
		$confirmPassword.on('invalid', setErrorMsg);
		$confirmPassword.on('input', setErrorMsg);
		$confirmPassword.on('change', setErrorMsg);
	}
}

(function ($) {
    $(function () {
        $('.userSalesPriceMinRefinement, .userSalesPriceMaxRefinement').on('change', function () {
            var form = $(this).parents('form');
            var submit = form.find('.submitPriceRefinementButton');
            var minPrice = parseInt(form.find('.userSalesPriceMinRefinement').val(), 10);
            var maxPrice = parseInt(form.find('.userSalesPriceMaxRefinement').val(), 10);

            if(maxPrice > minPrice) {
                submit.removeClass('disabled');
            } else if(isNaN(minPrice) && !isNaN(maxPrice)) {
                submit.removeClass('disabled');
            } else if(!isNaN(minPrice) && isNaN(maxPrice)) {
                submit.removeClass('disabled');
            } else {
                submit.addClass('disabled');
            }
        });

        $('.submitPriceRefinementButton').on('click', function () {
            return !$(this).hasClass('disabled');
        });

        // price clear
        $('.priceClearLink').on('click', function(e) {
            e.preventDefault();
            var tmpURL = window.location.href.replace(/\&*(userSalesPriceMin|userSalesPriceMax)=\d+/g,'');
            window.location = tmpURL;
        });
    });
})(jQuery);
